import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; /** for ngModel & forms **/

/*
Base UI includes { ng-zorro } as the base ui library
- Check https://ng.ant.design/docs/introduce/en for getting started with components
- Check /app/sandbox for UI samples 
*/
import { NgZorroAntdModule } from 'app/ng-zorro.module';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
registerLocaleData(en);
/*
Base UI includes { ngx-charts } was the base charting library
- Check Docs: https://swimlane.gitbook.io/ngx-charts/examples/pie-charts/pie-grid-chart
- Check Demo: https://swimlane.github.io/ngx-charts/#/ngx-charts/advanced-pie-chart
*/
import { NgxChartsModule } from '@swimlane/ngx-charts'; /* ngx-charts */

//Routing Module for the specific View Module
import { InboxSortService } from '../../BaseFramework/core/http'

//Routing Module for the specific View Module
import { PolicyServicingRoutingModule } from './policyServicing-routing.module'

//Shared Modules
import { SharedComponentsModule } from '../shared-components/shared-components.module'
import { SharedServicesModule } from '../shared-services/shared-services.module'
import { BaseUIModule } from '../../BaseFramework/base-ui/base-ui.module'

//ViewModule Components
// import { NBCaptureProposalComponent } from './nb-capture-proposal/nb-capture-proposal.component';

//Should be added for Translations to be loaded on Lazy Loads
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MultiLingualService } from 'app/BaseFramework/core/services';
import { ServicingComponent } from './servicing/servicing.component';

const services = [InboxSortService]
const _components = [ServicingComponent]


@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    SharedServicesModule,
    PolicyServicingRoutingModule,
    NgZorroAntdModule,
    NzIconModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    BaseUIModule,
    NgxChartsModule,
    TranslateModule.forChild({
      isolate: true
    })
  ],
  exports: [PolicyServicingRoutingModule, ..._components
    // NBCaptureProposalComponent
  ],
  declarations: [
    // NBCaptureProposalComponent,
    ..._components
  ],
  providers: [...services]
})
export class PolicyServicingModule { 

  //Should be added for Translations to be loaded on Lazy Loads
  constructor(private translateService: TranslateService,
    private multiLingualService:MultiLingualService) {
    this.multiLingualService.resetLanguageLocales(this.translateService)
  }

  
}
